import React from "react";
import { Link } from 'react-router-dom'
import axios from "axios";
import "../css/owner.css"
import { useState,useEffect } from 'react';


function Owner({ pets }) {

    const token =localStorage.getItem("token")

    const [user , setUser] = useState({});
    async function callAboutPage() {
      try {
        const response = await axios.get('https://petme.onrender.com/about', {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          withCredentials: true,
        });
    
        const data = response.data;
        setUser(data);
      } catch (error) {
        // Handle error
        console.error(error);
      }
    }
    
    useEffect(() => {
      callAboutPage();
    }, []);


    return (
        <div>
            <section id="info-type">
                {pets && pets.map((pet) => {
                    return (
                        <div className="col info-ownwer-section">
                            <div className="upperPortion">
                                <div class="info-box row-lg-6">
                                    <div className="info">
                                        <h2 className="info-name">{pet.petname} {pet.sex == "Male" ? <i id="info_venus" className="fa-solid fa-mars"></i> : <i id="info_venus" className="fa-solid fa-venus"></i>} </h2>
                                        <p className="info-breed">{pet.breed}</p>
                                        <p className="info-location"><i className="info-locationIcon fa-solid fa-location-dot"></i>{pet.address}</p>
                                        <ul className="info-list">
                                            <div id="data-row" className="row ">
                                                <div className="info-pet info-age"><p>Age&nbsp;&nbsp;&nbsp;<span className="info_data">{pet.age}</span></p></div>
                                                <div className="info-pet info-trained"><p className="p_info_pet">Trained&nbsp;&nbsp;&nbsp;<span className="info_data">{pet.trained}</span></p></div>
                                                <div className="info-pet info-neutered"><p className="p_info_pet">Neutered&nbsp;&nbsp;&nbsp;<span className="info_data">{pet.neutered}</span></p></div>
                                                <div className="info-pet info-vaccinated"><p className="p_info_pet">vaccinated&nbsp;&nbsp;&nbsp;<span className="info_data">{pet.vaccinated}</span></p></div>
                                            </div>

                                        </ul>
                                    </div>

                                </div>

                            </div>

                            <div class="info-box row-lg-6">
                                <div className="owner-box">
                                    <div className="owner">
                                        <div id="owner-row" className="row ">
                                            <h5 className="owner-name">{pet.ownername}<br /><span className="owner-tag">Parent</span></h5>
                                            {/* <i class="owner-phone fa-regular fa-phone"></i>
                                            <i class="owner-whtasapp fa-brands fa-whatsapp"></i>
                                            <i class="owner-email fa-regular fa-envelope"></i>
                                            <i class="owner-facebook fa-brands fa-facebook"></i> */}
                                        </div>
                                    </div>

                                    <div className="about_info">

                                        <p className="about-pet">{pet.petnote}</p>

                                        <Link className="adoption-link" to={!user.submit&&token?`/adoptform/${pet._id}`:"#"}onClick={() => {
                                                    if (!token) {
                                                    alert("Please login first");
                                                    }
                                                }}>
                                    <button className="adoption-btn">
                                        <i class="fa-solid fa-paw info-paw"></i>
                                        {user.submit&&<span className="info_adopt">Already Submited</span>}
                                        {!user.submit&&<span className="info_adopt">ADOPT</span>}

                                    </button>
                                </Link>


                                    </div>
                                </div>
                            </div>

                        </div>
                    )
                })}
            </section >
        </div >
    );
}


export default Owner;